/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Global_ResourcesInputs */



/**
* | output |
* | --- |
* | "Global Resources" |
*
* @param {Community_Global_ResourcesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_global_resources = /** @type {((inputs?: Community_Global_ResourcesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Global_ResourcesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ressources mondiales")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recursos globales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Recursos globais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risorse globali")
	return /** @type {LocalizedString} */ ("Global Resources")
});